<p class="field-label" [ngClass]="bold() ? 'bold' : 'thin'">
	{{ labelTranslateKey() | translate }}{{ asterisk() ? '*' : '' }}
</p>
